import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${({ theme }) => theme.v2.colors.neutral.white};
    display: flex;
    flex-direction: column;
    height: 547px;
    justify-content: flex-start;
    padding: 20px;
    width: 960px;
    max-width: 100%;
    overflow: hidden !important;
    
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      overflow: hidden !important;
      width: 100%;
      height: 100%;
    }
  `}
  `;

export const BannerTopImage = styled.img`
  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: calc(100% + 40px);
    }
  `}
`;

export const ModalTitle = styled.h2`
  ${({ theme }) => css`
    background: ${theme.v2.colors.gradient.secondary};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: ${theme.v2.font.family.primary};
    font-size: 28px;
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 140%;
    margin-bottom: 16px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm};
    }
 `}
`;

export const ModalDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 160%;
    margin-bottom: 30px;
    margin-top: 0;
    text-align: center;
 `}
`;

export const ButtonContainer = styled.div`
  ${({ theme }) => css`
    z-index: 5;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
    }
  `}
`;

export const SuccessAnimation = styled.img`
  width: 100%;
  height: auto;
  top: 0;
  position: absolute;
  object-fit: cover;
  max-height: 547px;

  @media (max-width: ${({ theme }) => theme.v2.breakpoints.sm}) {
    width: 125%;
  }
`;
